<template>
    <div class="companyManager">
        <el-breadcrumb class="Breadcrumb" separator="/">
            <el-breadcrumb-item>企业管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>
        <div class="search">
            <el-row :gutter="24">
                <el-col :span="6" :offset="0">
                    <el-input v-model="companyName" placeholder="请输入企业名称"></el-input>
                </el-col>
                <el-col :span="6" :offset="0">
                    <el-select v-model="auditStatus" filterable clearable placeholder="请选择" style="width: 100%;">
                        <el-option key="1" label="审核通过" value="1"></el-option>
                        <el-option key="3" label="未审核" value="3"></el-option>
                        <el-option key="2" label="审核不通过" value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="getListFun(1)" icon="el-icon-search">查询</el-button>
                    <el-button type="primary" @click="openCompany()" icon="el-icon-plus">创建企业</el-button>
                </el-col>
            </el-row>
        </div>
        <el-divider></el-divider>
        <div class="table">
            <el-table :data="tableData" stripe style="width: 100%">
                <!-- <el-table-column prop="id" label="id">
                </el-table-column> -->
                <!-- <el-table-column type="index" label="序号" width="200">
                </el-table-column> -->
                <el-table-column prop="companyName" label="公司名称">
                </el-table-column>
                <el-table-column prop="logo" label="公司Logo">
                    <template slot-scope="scope">
                        <el-image style="width: 80px; height: 80px" :src="scope.row.logo"
                            fit="contain"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="companyPerson" label="公司法人">
                </el-table-column>
                <el-table-column prop="personIdNumber" label="法人身份证">
                </el-table-column>
                <el-table-column prop="businessLicense" label="执照">
                    <template slot-scope="scope">
                        <el-image style="width: 150px; height: 150px" :src="scope.row.businessLicense"
                            fit="contain"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="creditCode" label="统一信用社代码">
                </el-table-column>
                <el-table-column prop="auditStatusStr" label="审核状态">
                </el-table-column>
                <el-table-column prop="createdDate" label="创建时间">
                </el-table-column>
                <el-table-column prop="id" fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.auditStatus != 1" @click="openEdit(scope.row)" type="text"
                            icon="el-icon-edit" size="small">审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--分页-->
        <div class="pagination">
            <el-pagination background @size-change="changSizeFun" @current-change="changpageFun"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum">
            </el-pagination>
        </div>
        <!-- 审核弹窗-->
        <el-dialog title="企业审核" :visible.sync="pop" width="650px">
            <el-form :model="audit" label-width="80px">
                <el-form-item label="企业介绍">
                    <el-input type="textarea" :rows="2" :disabled="true" v-model="audit.referral">
                    </el-input>
                </el-form-item>
                <el-form-item label="审核结果">
                    <el-select v-model="audit.resStatus" filterable placeholder="请选择审核结果" style="width: 100%;">
                        <el-option key="1" label="审核通过" value="1"></el-option>
                        <el-option key="2" label="审核不通过" value="2"></el-option>
                    </el-select>

                </el-form-item>
                <el-form-item label="审核原因">
                    <el-input type="textarea" :rows="2" placeholder="请输入审核原因" v-model="audit.res">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="pop = false">取 消</el-button>
                <el-button type="primary" @click="auditFun()">确 定</el-button>
            </div>
        </el-dialog>


        <!-- 创建企业-->
        <el-dialog title="添加企业" :visible.sync="addCompantPop" @close="resetForm('ruleForm')" width="25%">
            <el-form :model="formDate" :rules="rules" ref="ruleForm" label-width="80px">
                <el-form-item label="企业名称" prop="companyName" label-width="160px">
                    <el-input placeholder="请输入企业名称" v-model="formDate.companyName"></el-input>
                </el-form-item>
                <el-form-item label="企业Logo" prop="logo" label-width="160px">
                    <el-upload :action="uploadUrl" :headers="upheader" list-type="picture-card" :auto-upload="true"
                        :on-success="iconSuccess" :file-list="formDate.logoList"
                        accept="image/jpg,image/jpeg,image/png" :before-upload="iconBeforeUpload">
                        <i slot="default" class="el-icon-upload"></i>
                        <div slot="formDate" slot-scope="{formDate}">
                            <img class="el-upload-list__item-thumbnail" :src="formDate.logo" alt="">
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-delete" @click="iconRemove">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="企业法人" prop="companyPerson" label-width="160px">
                    <el-input placeholder="请输入企业法人" v-model="formDate.companyPerson"></el-input>
                </el-form-item>
                <el-form-item label="法人身份证号" prop="personIdNumber" label-width="160px">
                    <el-input placeholder="请输入法人身份证号" v-model="formDate.personIdNumber"></el-input>
                </el-form-item>
                <el-form-item label="企业统一信用代码" prop="creditCode" label-width="160px">
                    <el-input placeholder="请输入企业统一信用代码" v-model="formDate.creditCode"></el-input>
                </el-form-item>
                <el-form-item label="企业执照" prop="businessLicense" label-width="160px">
                    <el-upload :action="uploadUrl" :headers="upheader" list-type="picture-card" :auto-upload="true"
                        :on-success="linSuccess" :file-list="formDate.businessLicenseList"
                        accept="image/jpg,image/jpeg,image/png" :before-upload="iconBeforeUpload">
                        <i slot="default" class="el-icon-upload"></i>
                        <div slot="formDate" slot-scope="{formDate}">
                            <img class="el-upload-list__item-thumbnail" :src="formDate.businessLicense" alt="">
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-delete" @click="linRemove">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="企业性质" prop="propertyId" label-width="160px">
                    <el-select v-model="formDate.propertyId" filterable clearable placeholder="请选择企业性质"
                        style="width: 100%;">
                        <el-option v-for="item in selectProperty" :key="item.value" :label="item.label"
                            :value="parseInt(item.value)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="企业规模" prop="scaleId" label-width="160px">
                    <el-select v-model="formDate.scaleId" filterable clearable placeholder="请选择企业规模" style="width: 100%;">
                        <el-option v-for="item in selectScale" :key="item.value" :label="item.label"
                            :value="parseInt(item.value)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属行业" prop="fullGeneralDdicId" label-width="160px">
                    <el-cascader placeholder="请选择所属行业" :model="formDate.fullGeneralDdicId" clearable :options="selectGeneral"
                        filterable @change="selectJobDataJobChange" style="width: 100%;"></el-cascader>
                </el-form-item>
                <el-form-item label="企业介绍" prop="referral" label-width="160px">
                    <el-input type="textarea" placeholder="请输入企业介绍" v-model="formDate.referral"></el-input>
                </el-form-item>
                <el-form-item label="负责人电话" prop="mobile" label-width="160px">
                    <el-input placeholder="请输入负责人电话" v-model="formDate.mobile"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('ruleForm')">取 消</el-button>
                <el-button type="primary" @click="subFun('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    data() {
        return {
            companyName: '',
            auditStatus: '',
            pageSize: 10,
            pageNum: 1,
            tableData: [],
            totalNum: 0,
            audit: {
                companyId: '',
                referral: '',
                resStatus: '',
                res: '',
            },
            uploadUrl: '',
            upheader: {
                token: null
            },
            selectProperty: [],
            selectScale: [],
            selectGeneral: [],
            pop: false,
            addCompantPop: false,
            formDate: {},
            rules: {
                companyName: [
                    { required: true, message: '请输入企业名称', trigger: ['blur', 'change'] }
                ],
                companyPerson: [
                    { required: true, message: '请输入企业法人名称', trigger: ['blur', 'change'] }
                ],
                personIdNumber: [
                    { required: true, message: '请输入企业法人身份证号', trigger: ['blur', 'change'] }
                ],
                creditCode: [
                    { required: true, message: '请输入企业统一信用代码', trigger: ['blur', 'change'] }
                ],
                propertyId: [
                    { required: true, message: '请选择企业性质', trigger: ['blur', 'change'] }
                ],
                scaleId: [
                    { required: true, message: '请选择企业规模', trigger: ['blur', 'change'] }
                ],
                fullGeneralDdicId: [
                    { required: true, message: '请选择所属行业', trigger: ['blur', 'change'] }
                ],
                mobile: [
                    { required: true, message: '请输入负责人电话', trigger: ['blur', 'change'] }
                ]
            }
        }
    },
    mounted() {
        this.getList();
        this.getSelect();
    },
    methods: {
        //查询列表
        getList() {
            let data = {
                companyName: this.companyName,
                auditStatus: this.auditStatus,
                pageSize: this.pageSize,
                pageNum: this.pageNum,
            }
            this.$get(api + "/companyManager/getList", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.tableData = res.data;
                    this.totalNum = res.totalNum
                }
            })
        },
        getSelect() {
            let data = {}
            this.$get(api + "/companyManager/getSelectProperty", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.selectProperty = res.data;
                }
            })
            this.$get(api + "/companyManager/getSelectScale", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.selectScale = res.data;
                }
            })
            this.$get(api + "/companyManager/getSelectGeneral", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.selectGeneral = res.data;
                }
            })
        },
        //企业审核打开弹窗
        openEdit(comId) {
            this.audit = {};
            this.audit.companyId = comId.id;
            this.audit.referral = comId.referral;
            this.pop = true
        },
        //审核提交
        auditFun() {
            let data = this.audit
            this.$post(api + "/companyManager/addCompanyAudit", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '审核完成'
                        });
                        this.pop = false
                        this.getList();
                    } else {
                        this.$message.error(res.desc);
                    }
                }
            })
        },
        selectJobDataJobChange(value) {
            console.log(value)
            this.formDate.generalDdicId = value[value.length - 1];
            this.formDate.fullGeneralDdicId = value;
        },
        //新增企业打开弹窗
        openCompany() {
            this.uploadUrl = api + '/main/license/upload'
            this.upheader = { "token": this.$store.state.userInfo.token }
            this.$nextTick(() => {
                this.formDate = {};
                this.formDate.logo = "https://oss.jlszhgh.com/employment/images/default_logo.png";
                this.formDate.businessLicense = '';
                this.formDate.logoList = [{
                    uid: "https://oss.jlszhgh.com/employment/images/default_logo.png",
                    url: "https://oss.jlszhgh.com/employment/images/default_logo.png"
                }];
                this.formDate.businessLicenseLisy = [];

            })
            this.addCompantPop = true;
        },

        //弹窗确定
        subFun(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.addFun();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //提交企业
        addFun() {
            let data = {
                companyName: this.formDate.companyName, //企业名称
                logo: this.formDate.logo,//企业头像
                fullGeneralDdicId: this.formDate.fullGeneralDdicId.toString(),//所属行业全路径
                generalDdicId: this.formDate.generalDdicId,//所属行业DDIC
                propertyId: this.formDate.propertyId,//企业性质
                scaleId: this.formDate.scaleId,//规模
                referral: this.formDate.referral,//企业介绍
                companyPerson: this.formDate.companyPerson,//企业法人
                personIdNumber: this.formDate.personIdNumber,//法人身份证号
                businessLicense: this.formDate.businessLicense,//企业执照
                creditCode: this.formDate.creditCode,//企业统一信用代码
                mobile: this.formDate.mobile,//用户电话
            }
            this.$post(api + "/companyManager/companyAuthentication", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '添加成功!'
                    })
                    this.addCompantPop = false;
                    this.getListFun(1);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },
        //关闭弹窗
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.addCompantPop = false;
        },

        //特定pageNum查询列表
        getListFun(val) {
            this.pageNum = val;
            this.getList();
        },

        //更换pageSize
        changSizeFun(val) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.getList();
        },
        //翻页
        changpageFun(val) {
            console.log(this.pageNum);
        },
        //关闭弹窗
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.addCompantPop = false;
        },

        //特定pageNum查询列表
        getListFun(val) {
            this.pageNum = val;
            this.getList();
        },

        //更换pageSize
        changSizeFun(val) {
            console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.getList();
        },
        //翻页
        changpageFun(val) {
            console.log(this.pageNum);
            this.pageNum = val;
            this.getList();
        },


        iconBeforeUpload(file) {
            var img = file.name.substring(file.name.lastIndexOf('.') + 1)
            const suffix = img === 'jpg'
            const suffix2 = img === 'png'
            const suffix3 = img === 'jpeg'
            // const isLt1M = file.size / 1024 / 1024 < 1;
            if (!suffix && !suffix2 && !suffix3) {
                this.$message.error("只能上传图片！");
                return false
            }
            // 可以限制图片的大小
            // if (!isLt1M) {
            //     this.$message.error('上传图片大小不能超过 1MB!');
            // }
            return suffix || suffix2 || suffix3
        },
        iconSuccess(response, file, fileList) {
            this.formDate.logo = response.data.fullUrl;
            this.formDate.logoList = [file]
        },
        iconRemove() {
            this.formDate.logo = '';
            this.formDate.logoList = [];

        },
        linSuccess(response, file, fileList) {
            this.formDate.businessLicense = response.data.fullUrl;
            this.formDate.businessLicenseList = [file]
        },
        linRemove() {
            this.formDate.businessLicense = '';
            this.formDate.businessLicenseList = [];
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/company/company/CompanyManager.vue